// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .tooltip-inner {
  font-size: 150%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/additional-content-details/additional-content-details-broadcaster/club-content-session-request-broadcaster/club-content-session-request-broadcaster.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF","sourcesContent":["::ng-deep .tooltip-inner {\n  font-size: 150%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
